exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".glance[data-v-71cb3e20]{background-color:#fff;margin-left:-1.5rem;margin-right:-1.5rem;padding-left:1.5rem;padding-right:1.5rem}.section-body[data-v-71cb3e20]{display:flex;flex-wrap:wrap}.section-property-block[data-v-71cb3e20]{margin-right:1rem;margin-bottom:1rem;min-width:140px}.section-property-title[data-v-71cb3e20]{color:#6d6d6d;font-family:Hind Light,sans-serif;text-transform:uppercase;margin-bottom:1rem;font-size:.875rem;line-height:.875rem}.section-property-container[data-v-71cb3e20]{height:2rem}.section-property[data-v-71cb3e20]{color:#565656;border:none;font-family:Hind Regular;word-wrap:break-word}@media (min-width:576px){.col-sm-2[data-v-71cb3e20]{max-width:15.666667%}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-71cb3e20","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Glance.vue
// module id = 778
// module chunks = 0